// extracted by mini-css-extract-plugin
export default {"breadCrumbs":"Breadcrumbs_breadCrumbs__Gj6fG","active":"Breadcrumbs_active__naYPE"};